<script>
export default {
	name: 'IconSvgFlac',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: Number,
			default: '40',
		},
		height: {
			type: Number,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.4781 4.10333C13.0134 4.10289 12.5679 3.92171 12.2393 3.59956C11.9107 3.2774 11.7259 2.84059 11.7254 2.385V0H3.89355C3.28691 0 2.70511 0.236262 2.27615 0.656812C1.84719 1.07736 1.6062 1.64775 1.6062 2.2425V15.7608C1.6071 16.355 1.84849 16.9245 2.27735 17.3444C2.70621 17.7642 3.28749 18 3.89355 18H13.2954C13.9016 18 14.483 17.7641 14.9119 17.3441C15.3408 16.9241 15.5821 16.3543 15.5827 15.76V4.10333H13.4781Z"
				:fill="color" />
			<path
				d="M15.5826 4.10333H13.478C13.0133 4.10289 12.5678 3.92171 12.2392 3.59956C11.9106 3.2774 11.7258 2.84059 11.7253 2.385V0L15.5826 4.10333Z"
				fill="#0055A3" />
			<path
				d="M17.2411 14.2166H6.61266C5.85873 14.2166 5.24756 14.8157 5.24756 15.5549V18.6615C5.24756 19.4007 5.85873 19.9999 6.61266 19.9999H17.2411C17.995 19.9999 18.6062 19.4007 18.6062 18.6615V15.5549C18.6062 14.8157 17.995 14.2166 17.2411 14.2166Z"
				fill="#0055A3" />
			<path
				d="M16.4597 16.0904C16.6753 16.2624 16.8219 16.5035 16.8736 16.7712H16.2192C16.175 16.6603 16.0977 16.565 15.9973 16.4979C15.8915 16.4304 15.7674 16.3958 15.6412 16.3988C15.5579 16.3961 15.475 16.4124 15.3991 16.4462C15.3232 16.48 15.2563 16.5305 15.2035 16.5938C15.0851 16.7422 15.0248 16.9272 15.0335 17.1154C15.0248 17.3028 15.0851 17.4871 15.2035 17.6346C15.2567 17.6972 15.3238 17.747 15.3996 17.7804C15.4755 17.8138 15.5581 17.8297 15.6412 17.827C15.7674 17.8303 15.8917 17.7957 15.9973 17.7279C16.0971 17.662 16.1744 17.5682 16.2192 17.4587H16.8736C16.821 17.7256 16.6745 17.966 16.4597 18.1379C16.2285 18.3109 15.9429 18.3993 15.6522 18.3879C15.4232 18.3926 15.1972 18.3367 14.9978 18.2262C14.8112 18.1198 14.6598 17.963 14.5617 17.7745C14.4564 17.5678 14.4039 17.339 14.4088 17.1079C14.404 16.8768 14.4564 16.6481 14.5617 16.4413C14.6598 16.2528 14.8112 16.096 14.9978 15.9896C15.1972 15.8791 15.4232 15.8232 15.6522 15.8279C15.9444 15.8204 16.23 15.9132 16.4597 16.0904Z"
				fill="#F3F3F6" />
			<path
				d="M13.3326 17.8583H12.3739L12.2149 18.3158H11.5647L12.4997 15.8275H13.2119L14.1469 18.3158H13.489L13.3326 17.8583ZM13.1728 17.3975L12.8549 16.4767L12.5337 17.3975H13.1728Z"
				fill="#F3F3F6" />
			<path d="M10.4749 17.8691H11.3028V18.3332H9.85779V15.8275H10.4766L10.4749 17.8691Z" fill="#F3F3F6" />
			<path d="M9.55583 15.8275V16.3092H8.52832V16.8583H9.32249V17.3192H8.52832V18.3334H7.92249V15.8275H9.55583Z"
				  fill="#F3F3F6" />
			<path d="M7.62015 17.7527V18.3585H6.9801V17.7527H7.62015Z" fill="#F3F3F6" />
			<path
				d="M11.8258 10.9934H10.8951V7.30505C10.8951 7.1815 10.845 7.06302 10.7559 6.97565C10.6668 6.88829 10.5459 6.83922 10.4199 6.83922H8.03991C7.97752 6.83922 7.91573 6.85126 7.85808 6.87467C7.80043 6.89809 7.74805 6.9324 7.70393 6.97565C7.65981 7.01891 7.62481 7.07027 7.60093 7.12678C7.57705 7.1833 7.56476 7.24387 7.56476 7.30505V10.9934H6.62976V6.99338C6.62976 6.85302 6.65798 6.71403 6.71279 6.58436C6.76761 6.45469 6.84795 6.33688 6.94923 6.23766C7.0505 6.13845 7.17074 6.05977 7.30304 6.00613C7.43535 5.95249 7.57714 5.92494 7.72031 5.92505H10.7378C11.0268 5.92505 11.304 6.0376 11.5083 6.23796C11.7127 6.43831 11.8275 6.71004 11.8275 6.99338L11.8258 10.9934Z"
				fill="#0055A3" />
			<path
				d="M10.7224 12.075C11.3318 12.075 11.8257 11.5907 11.8257 10.9933C11.8257 10.3959 11.3318 9.91162 10.7224 9.91162C10.1131 9.91162 9.61914 10.3959 9.61914 10.9933C9.61914 11.5907 10.1131 12.075 10.7224 12.075Z"
				fill="#0055A3" />
			<path
				d="M6.46646 12.075C7.0758 12.075 7.56976 11.5907 7.56976 10.9933C7.56976 10.3959 7.0758 9.91162 6.46646 9.91162C5.85712 9.91162 5.36316 10.3959 5.36316 10.9933C5.36316 11.5907 5.85712 12.075 6.46646 12.075Z"
				fill="#0055A3" />
		</svg>
	</div>
</template>

<style scoped>

</style>